function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlutterSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "file_type_flutter") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polyline", {
    points: "15.383 18.316 18.744 15.042 27.093 15.042 19.697 22.438 15.383 18.316 15.383 18.316 15.383 18.316 15.383 18.316 15.383 18.316",
    style: {
      fill: "#40d0fd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "4.907 16.125 9.106 20.424 27.093 2.287 18.744 2.287 4.907 16.125",
    style: {
      fill: "#41d0fd",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "11.176 22.479 15.435 26.675 19.697 22.438 15.383 18.316 11.176 22.479",
    style: {
      fill: "#1fbcfd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "15.435 26.675 19.697 22.438 26.989 29.813 18.593 29.813 15.435 26.675",
    style: {
      fill: "#095a9d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "15.435 26.675 19.406 25.354 18.068 24.057 15.435 26.675",
    style: {
      fill: "#0e5199"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlutterSvgrepoCom);
export default __webpack_public_path__ + "static/media/flutter-svgrepo-com.50bb17c0e69f24a17adbcca9bd6e8528.svg";
export { ForwardRef as ReactComponent };